import axios from 'axios';
import store from './store';

const Utils = {
    URLEncode:function(element,key,list){
        list = list || [];
        if(typeof(element)=='object'){
          for (var idx in element)
          Utils.URLEncode(element[idx],key?key+'['+idx+']':idx,list);
        } else {
          list.push(key+'='+encodeURIComponent(element));
        }
        return list.join('&');
      },
    Crud: {
        getList: async function(resource) {
            var url =store.state.server +  `/${resource}/list`;
            try {
                var response= await axios.get(url,{ auth: { username: store.state.username, password: store.state.password }});
                if(response.data.type === 'OK') {
                    return response.data.results;
                    
                }else{
                    throw response.data.result;
                }
            }catch(e) {
                console.log(e);
                throw(`Error getting ${resource} list:\n${e}`);
            }
        },
        getView: async function(resource, itemId) {
            var url = store.state.server + `/${resource}/view/${encodeURIComponent(itemId)}`;
            try {
                var response = await axios.get(url, { auth: { username: store.state.username, password: store.state.password } });
                if (response.data.type === 'OK') {
                    if (Array.isArray(response.data.results)) {
                        return response.data.results[0] || null;
                    }
                    return response.data.results || null;
                } else {
                    throw response.data.result;
                }
            } catch (e) {
                console.log(e);
                throw(`Error getting ${resource} detail:\n${e}`);
            }
        },
        getMessagePayload: async function(messageId) {
            var url = store.state.server + `/messages/payload/${encodeURIComponent(messageId)}`;
            try {
                var response = await axios.get(url, {
                    auth: { username: store.state.username, password: store.state.password },
                });
                return response.data || null;
            } catch (e) {
                console.log(e);
                var errorText = `Error loading payload for message ${messageId}`;
                if (e && e.response && e.response.data) {
                    if (typeof e.response.data === 'string') {
                        errorText = e.response.data;
                    } else if (e.response.data.message) {
                        errorText = e.response.data.message;
                    }
                }
                throw(errorText);
            }
        },
        downloadMessageFile: async function(messageId, fallbackFilename) {
            var url = store.state.server + `/messages/download/${encodeURIComponent(messageId)}`;
            try {
                var response = await axios.get(url, {
                    auth: { username: store.state.username, password: store.state.password },
                    responseType: 'blob',
                });
                var disposition = response.headers['content-disposition'] || '';
                var filename = fallbackFilename || 'message.dat';
                var utfMatch = disposition.match(/filename\*=UTF-8''([^;]+)/i);
                var standardMatch = disposition.match(/filename="([^"]+)"|filename=([^;]+)/i);
                if (utfMatch && utfMatch[1]) {
                    filename = decodeURIComponent(utfMatch[1]);
                } else if (standardMatch) {
                    filename = standardMatch[1] || standardMatch[2] || filename;
                }

                var blobUrl = window.URL.createObjectURL(response.data);
                var link = document.createElement('a');
                link.href = blobUrl;
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(blobUrl);
                return true;
            } catch (e) {
                console.log(e);
                var errorText = `Error downloading file for message ${messageId}`;
                if (e && e.response && e.response.data && typeof e.response.data.text === 'function') {
                    try {
                        var responseText = await e.response.data.text();
                        if (responseText) {
                            errorText = responseText;
                        }
                    } catch (textError) {
                        console.log(textError);
                    }
                }
                throw(errorText);
            }
        },
        getListChart: async function(resource,range) {
            var url =store.state.server +  `/${resource}/data_charts?startDate=${range.startDate}&endDate=${range.endDate}`;
            try {
                var response= await axios.get(url,{ auth: { username: store.state.username, password: store.state.password }});
                if(response.data.type === 'OK') {
                    return response.data.results;
                    
                }else{
                    throw response.data.result;
                }
            }catch(e) {
                console.log(e);
                throw(`Error getting ${resource} list:\n${e}`);
            }
        },
        getObject: async function(resource, index, empty) {
            console.log(`Loading Object ${index} from ${resource}`);
            var emptyObject = Object.assign({}, empty , {"_id":null });
            if(index === 'new') return emptyObject;
            var list = await this.getList(resource);
            console.log(list);
            var item =list[index];
            var url=store.state.server +  `/${resource}/view/${item}`;
            console.log(url);
            try {
                var response= await axios.get(url ,{  auth: { username: store.state.username, password: store.state.password } });
                if(response.data.type == 'OK') {
                    var results=response.data.results[0];
                    results._id = index;
                    return results;
                }else{
                    throw response.data.result;
                }
            }catch(e) {
                console.log(e);
                throw(`Error loading Object ${index}:\n${e}`);
            }
        },
        getObjectFilter: async function(resource, index, empty) {
            var url=store.state.server +  `/${resource}/filter/${empty.name}`;
            console.log(url);
            try {
                var response= await axios.get(url ,{  auth: { username: store.state.username, password: store.state.password } });
                if(response.data.type == 'OK') {
                    var results=response.data.results[0];
                    results._id = index;
                    return results;
                }else{
                    throw response.data.result;
                }
            }catch(e) {
                console.log(e);
                throw(`Error loading Object ${index}:\n${e}`);
            }
        },
        saveObject: function(resource, data) {
            console.log('Saving',data);
            var old_id=data._id;
            // delete data._id;
            if(old_id !== null) {
                return this.deleteObject(resource,old_id).then( () => this.createObject(resource,data));
            }else{
                return this.createObject(resource,data);
            }
            
        },
        importCertificate: async function(data) {
            console.log('Creating',data);
            var url=store.state.server +  `/cert/importbystream/${data.alias}` ;
            try {
                var form = '';
                if(data._prefix) {
                    form = data._prefix + '&';
                }
                delete data._prefix;
                form += Utils.URLEncode(data);
                console.log('Posting Data', form);
                var response = await axios.post(url,form,{  auth: { username: store.state.username, password: store.state.password } });
                if(response.data.type === 'OK') {
                    return true;
                }else{
                    throw response.data.result;
                }
            }catch(e) {
                console.log(e,url);
                throw(`Error Creating Object:\n${e}`);
            }
        },
        createObject: async function(resource,data) {
            console.log('Creating',data);
            var url=store.state.server +  `/${resource}/add/${data.name}` ;
            try {
                var form = '';
                if(data._prefix) {
                    form = data._prefix + '&';
                }
                delete data._prefix;
                form += Utils.URLEncode(data);
                console.log('Posting Form', form);
                var response = await axios.post(url,form,{  auth: { username: store.state.username, password: store.state.password } });
                if(response.data.type === 'OK') {
                    return true;
                }else{
                    throw response.data.result;
                }
            }catch(e) {
                console.log(e,url);
                throw(`Error Creating Object:\n${e}`);
            }
        },
        deleteObject: async function(resource,index) {
            console.log('Deleting',index);
            var list = await this.getList(resource);
            var item =list[index];
            var url=store.state.server +  `/${resource}/delete/${item}`;
            try {
                var response = await axios.get(url,{  auth: { username: store.state.username, password: store.state.password } });
                if(response.data.type === 'OK') {
                    //var results=response.data.result;
                    return true;
                }else{
                    throw response.data.result;
                }
            }catch(e) {
                console.log(e,url);
                throw(`Error deleting Object ${index}:\n${e}`);
            }
        }
    }
};
export default Utils;
